// src/components/CartHeader.jsx
import React from "react";
import { ShoppingCart } from "lucide-react";

const CartHeader = ({ items, catalogItems }) => {
  return (
    <div className="cart-header">
      <ShoppingCart className="cart-icon" size={32} />
      <h1>Your Cart</h1>
      <span className="item-count">
        {items.length > 0 &&
          `${items.length} photo item${items.length !== 1 ? "s" : ""}`}
        {items.length > 0 && catalogItems.length > 0 && ", "}
        {catalogItems.length > 0 &&
          `${catalogItems.length} catalog item${
            catalogItems.length !== 1 ? "s" : ""
          }`}
      </span>
    </div>
  );
};

export default CartHeader;